import { axiosClientAdmin } from '@/lib/auth';
import { Filter, FilterGroup, FilterOperator, SortOrder } from '@/lib/utils';

export interface TenantMonitoringCompanyDto {
  id?: string;
  monitoringCompanyName?: string;
  externalId?: string;
  order?: number;
}

export interface TenantMonitoringCompaniesSearched {
  success?: boolean;
  message?: string;
  code?: string;
  errors?: string[];
  totalRows?: number;
  rows?: TenantMonitoringCompanySearchDto[];
}

export interface TenantMonitoringCompanySearchDto {
  id?: string;
  name?: string;
  domain?: string;
  deletedAt?: Date;
  primaryEmail?: string;
  userId?: string;
  isDefault?: boolean;
  defaultOrder?: number;
  ownedById?: string;
  ownedBy?: string;
}

export async function getSearchTenantsTenantMonitoring(
  tenantId: string,
  params: {
    pageNumber?: number;
    pageSize?: number;
    sortBy?: string;
    sortDir?: SortOrder;
    filterOperator?: FilterOperator;
    filterFilters?: Filter[];
    filterFilterGroups?: FilterGroup[];
  } = {}
) {
  try {
    const response = await axiosClientAdmin.get<TenantMonitoringCompaniesSearched>(
      `/tenants/${tenantId}/TenantMonitoring/companies/search`,
      {
        params: {
          PageNumber: params.pageNumber,
          PageSize: params.pageSize,
          SortBy: params.sortBy,
          SortDir: params.sortDir,
          'Filter.Operator': params.filterOperator,
          'Filter.Filters': params.filterFilters,
          'Filter.FilterGroups': params.filterFilterGroups,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error searching tenant monitoring companies:', error);
    throw error;
  }
}
